import { Container, FooterRights } from './Footer.styles'

export const Footer = () => {
  const year = new Date().getFullYear()

  const handleClickPoweredBy = () => {
    window.open('https://modalgr.com.br/')
  }

  return (
    <Container>
      <FooterRights>
        <span></span>
        <span>© {year} CSN | Todos os direitos reservados.</span>
        <a onClick={handleClickPoweredBy}>Powered by ModalGR</a>
      </FooterRights>
    </Container>
  )
}
